"use client";
import {
  PureCarousel as PureCarouseComponent,
  type PureCarouselProps,
} from "@cgc/ui/pure-carousel";

export default function PureCarousel(props: PureCarouselProps) {
  return <PureCarouseComponent {...props} />;
}
